import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cancelOrder, fetchOrderDetailByID } from '@/redux/actions';
import { IS_MOBILE } from '@/utils/checkClientDeviceType';
import { getVisibleStorePhone } from 'src/utils/getContactDetails';

const CancelOrderModal = ({
  showCancellationOptions,
  setShowCancellationModal,
  setShowMoreOptions,
  setIsCancelModalOpen,
}) => {
  const dispatch = useDispatch();
  const [selectedMessageValue, setSelectedMessageValue] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [showNextModal, setShowNextModal] = useState(false);

  const { orderDetails, storeData } = useSelector((state) => ({
    orderDetails: state.orderReducer.orderDetails,
    storeData: state.storeReducer.store,
  }));

  const handleClose = () => {
    setShowCancellationModal(false);
    setIsCancelModalOpen(false);
  };

  const handleChange = (reason) => {
    setSelectedMessageValue(reason);
  };

  const handleSubmit = () => {
    if (selectedMessageValue === 'Other' && customReason.length < 10) {
      return;
    }
    const payload = {
      id: orderDetails.order_id,
      text: selectedMessageValue === 'Other' ? customReason : selectedMessageValue,
    };
    dispatch(cancelOrder(payload));
    dispatch(fetchOrderDetailByID({ order_id: orderDetails?.order_id }));
    setShowCancellationModal(false);
    setShowMoreOptions(false);
    window.location.reload();
  };

  const storePhone = getVisibleStorePhone(storeData);

  const msgValues = [
    'Incorrect items ordered',
    'Ordered by mistake',
    'Want to change variant',
    'Item(s) not required anymore',
    'Other',
  ];

  const isPrepaid = orderDetails?.payment_status == 9;

  const handleNext = () => {
    if (isPrepaid) {
      setShowNextModal(true);
    } else {
      handleSubmit();
    }
  };

  if (IS_MOBILE)
    return (
      <div className="cancel-option-modal-overlay-mobile">
        <div className="cancel-option-modal-mobile">
          <div className="cancel-modal-main-heading-mobile">
            <div className="cancel-modal-heading-text-mobile">Cancel Order</div>
            <img
              loading="lazy"
              src="https://cdn.dotpe.in/longtail/social_media_templates/7612844/DL67whIR.jpeg"
              className="cancel-icon-mobile"
              alt="cancel"
              onClick={handleClose}
            />
          </div>
          <div className="cancel-modal-body-mobile">
            {!showNextModal && (
              <>
                <div className="cancel-modal-description-mobile">
                  Please tell us the correct reason for cancellation. This information is
                  only used to improve our service.
                </div>
                <div className="cancel-modal-options-mobile">
                  {msgValues.map((reason, index) => (
                    <div
                      className="cancel-modal-option-mobile"
                      key={index}
                      onClick={() => handleChange(reason)}
                    >
                      <input
                        type="radio"
                        checked={selectedMessageValue === reason}
                        value={reason}
                        key={index}
                      />
                      <label>{reason}</label>
                    </div>
                  ))}
                </div>
                {selectedMessageValue === 'Other' && (
                  <textarea
                    name="custom-reason"
                    value={customReason}
                    onChange={(e) => setCustomReason(e.target.value)}
                    placeholder="Describe any other reasons"
                    className="custom-cancel-input-box-mobile"
                    maxLength={40}
                    rows={7}
                  />
                )}
                <button
                  className={`cancel-order-btn-mobile${
                    (selectedMessageValue.length > 0 &&
                      selectedMessageValue !== 'Other') ||
                    (selectedMessageValue === 'Other' && customReason.length >= 10)
                      ? '-selected'
                      : ''
                  }`}
                  onClick={handleNext}
                >
                  <div
                    className={`cancel-order-btn-txt-mobile${
                      (selectedMessageValue.length > 0 &&
                        selectedMessageValue !== 'Other') ||
                      (selectedMessageValue === 'Other' && customReason.length >= 10)
                        ? '-selected'
                        : ''
                    }`}
                  >
                    {isPrepaid ? 'Next' : 'Submit and cancel order'}
                  </div>
                </button>
              </>
            )}
            {showNextModal && isPrepaid && (
              <div className="cancel-next-modal-mobile">
                <div className="cancel-next-modal-description-mobile">
                  Your order will be cancelled.
                  <br />
                  <br />
                  Refund will be issued manually by the merchant. For quicker help,
                  contact:{' '}
                  <span style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                    {storePhone}
                  </span>
                </div>
                <button
                  className={`cancel-order-btn-mobile-selected`}
                  onClick={handleNext}
                  style={{ marginTop: '2rem' }}
                >
                  <div className={`cancel-order-btn-txt-mobile-selected`}>
                    Submit and cancel order
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );

  return (
    <div className="cancel-option-modal-overlay">
      <div
        open={showCancellationOptions}
        fullWidth={true}
        className="cancel-option-modal"
        maxWidth="sm"
        onClose={handleClose}
      >
        {!showNextModal && (
          <>
            <div className="cancel-modal-static">
              <div className="cancel-modal-headings">
                <div className="cancel-modal-main-heading">
                  <div className="cancel-modal-heading-text">Cancel Order</div>
                  <img
                    loading="lazy"
                    src="https://cdn.dotpe.in/longtail/social_media_templates/7612844/DL67whIR.jpeg"
                    className="cancel-icon"
                    alt="cancel"
                    onClick={handleClose}
                  />
                </div>
                <div className="cancel-modal-description">
                  Please tell us the correct reason for cancellation. This information is
                  only used to improve our service.
                </div>
              </div>
              <div className="cancel-modal-options-box">
                {msgValues.map((reason, index) => (
                  <div
                    className="cancel-modal-option"
                    key={index}
                    onClick={() => handleChange(reason)}
                  >
                    <input
                      type="radio"
                      checked={selectedMessageValue === reason}
                      value={reason}
                      key={index}
                      minLength={10}
                    />
                    <label>{reason}</label>
                  </div>
                ))}
              </div>
            </div>
            {selectedMessageValue === 'Other' && (
              <textarea
                name="custom-reason"
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                placeholder="Describe any other reasons"
                className="custom-cancel-input-box"
                maxLength={40}
              />
            )}
            <div
              className={`cancel-order-div${
                (selectedMessageValue.length > 0 && selectedMessageValue !== 'Other') ||
                (selectedMessageValue === 'Other' && customReason.length >= 10)
                  ? '-selected'
                  : ''
              }`}
            >
              <button
                className={`cancel-order-btn${
                  (selectedMessageValue.length > 0 && selectedMessageValue !== 'Other') ||
                  (selectedMessageValue === 'Other' && customReason.length >= 10)
                    ? '-selected'
                    : ''
                }`}
                onClick={handleNext}
              >
                <div
                  className={`cancel-order-btn-txt${
                    (selectedMessageValue.length > 0 &&
                      selectedMessageValue !== 'Other') ||
                    (selectedMessageValue === 'Other' && customReason.length >= 10)
                      ? '-selected'
                      : ''
                  }`}
                >
                  {isPrepaid ? 'Next' : 'Submit and cancel order'}
                </div>
              </button>
            </div>
          </>
        )}
        {showNextModal && isPrepaid && (
          <div className="cancel-modal-static">
            <div className="cancel-modal-headings">
              <div className="cancel-modal-main-heading">
                <div className="cancel-modal-heading-text">Cancel Order</div>
                <img
                  loading="lazy"
                  src="https://cdn.dotpe.in/longtail/social_media_templates/7612844/DL67whIR.jpeg"
                  className="cancel-icon"
                  alt="cancel"
                  onClick={handleClose}
                />
              </div>
              <div className="cancel-modal-description">
                Your order will be cancelled.
                <br />
                <br />
                Refund will be issued manually by the merchant. For quicker help, contact:{' '}
                <span style={{ fontWeight: 'bold', fontSize: '1rem' }}>{storePhone}</span>
              </div>
            </div>
            <div
              className="cancel-order-div-selected"
              style={{
                position: 'absolute',
                bottom: '2rem',
                width: '100%',
                left: '20px',
              }}
            >
              <button className="cancel-order-btn-selected" onClick={handleSubmit}>
                <div className="cancel-order-btn-txt-selected">Confirm Cancellation</div>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CancelOrderModal;
